import React from "react";

// components

import CardTable2 from "components/Cards/CardTable2";

export default function ProyeccionProd() {
  return (
    <>
      <div className="flex flex-wrap">
        <div className="w-full px-4">
          <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
            <CardTable2 />
          </div>
        </div>
      </div>
    </>
  );
}
